import React from "react";
import { Box } from "@mui/material";
import MetricCard from "../../Metrics/components/MetricCard";
import { KPI_COLORS, dimSx } from "../../../styles/tokens";
import {
  CurrencyRuble,
  TrendingUp,
  Percent,
  AttachMoney,
  Discount,
} from "@mui/icons-material";

/**
 * Контейнер карточек метрик себестоимости
 */
const CostMetricsCards = ({ metrics, loading, dimmed = false }) => {
  if (!metrics && !loading) return null;

  const {
    totalCost = 0, // Себестоимость продаж (₽)
    totalProfit = 0, // Валовая прибыль (₽)
    costPercent = 0, // Себестоимость (%)
    markupPercent = 0, // Наценка (%)
    totalMarkup = 0, // Наценка (₽)
    totalDiscount = 0, // Сумма скидки (₽)
  } = metrics || {};

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: {
          xs: "repeat(2, minmax(0, 1fr))",
          md: "repeat(2, minmax(0, 1fr))",
          lg: "repeat(4, minmax(0, 1fr))",
        },
        gap: { xs: 1.5, md: 2 },
        width: "100%",
        maxWidth: { xs: 800, md: "100%" },
        alignItems: "stretch",
        ...dimSx(dimmed),
      }}
    >
      {/* Валовая прибыль (₽) - главная, на все колонки */}
      <Box sx={{ gridColumn: "1 / -1" }}>
        <MetricCard
          icon={TrendingUp}
          title="Валовая прибыль"
          valueNumber={totalProfit}
          format={(n) =>
            Number(n).toLocaleString("ru-RU", {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0,
            }) + " "
          }
          suffix="₽"
          color={KPI_COLORS.grossProfit}
          loading={loading}
          large={true}
        />
      </Box>

      {/* Себестоимость продаж (₽) */}
      <MetricCard
        icon={CurrencyRuble}
        title="Себестоимость продаж"
        valueNumber={totalCost}
        format={(n) =>
          Number(n).toLocaleString("ru-RU", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }) + " "
        }
        suffix="₽"
        color={KPI_COLORS.costMain}
        loading={loading}
      />

      {/* Себестоимость (%) */}
      <MetricCard
        icon={Percent}
        title="Себестоимость %"
        valueNumber={costPercent}
        format={(n) =>
          Number(n).toLocaleString("ru-RU", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) + " "
        }
        suffix="%"
        color={KPI_COLORS.costPercent}
        loading={loading}
      />

      {/* Наценка (%) */}
      <MetricCard
        icon={Percent}
        title="Наценка %"
        valueNumber={markupPercent}
        format={(n) =>
          Number(n).toLocaleString("ru-RU", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }) + " "
        }
        suffix="%"
        color={KPI_COLORS.markupPercent}
        loading={loading}
      />

      {/* Сумма скидки (₽) */}
      <MetricCard
        icon={Discount}
        title="Сумма скидки"
        valueNumber={totalDiscount}
        format={(n) =>
          Number(n).toLocaleString("ru-RU", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          }) + " "
        }
        suffix="₽"
        color={KPI_COLORS.costDiscountSum}
        loading={loading}
      />
    </Box>
  );
};

export default CostMetricsCards;

